<template>
  <div id="app">
    <div :class="showNav ? 'page-content' : ''">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <div class="nav" v-show="showNav">
      <van-tabbar
        v-model="active"
        :active-color="theme['c1']"
        :z-index="zIndex"
        v-if="isdefault && !IsMemberVersion"
        :safe-area-inset-bottom="true"
      >
        <van-tabbar-item icon="home-o" @click="memuChange('show')"
          >首页</van-tabbar-item
        >
        <van-tabbar-item icon="apps-o" @click="memuChange('goods')"
          >分类</van-tabbar-item
        >
        <van-tabbar-item
          id="carto"
          icon="cart-o"
          :info="goodstotal"
          v-if="goodstotal > 0"
          @click="memuChange('cart')"
          >购物车</van-tabbar-item
        >
        <van-tabbar-item
          icon="cart-o"
          id="carto"
          v-else
          @click="memuChange('cart')"
          >购物车</van-tabbar-item
        >
        <van-tabbar-item icon="user-o" @click="memuChange('user')"
          >我的</van-tabbar-item
        >
      </van-tabbar>
      <van-tabbar
        v-model="active"
        :active-color="theme['c1']"
        :z-index="zIndex"
        v-if="isdefault && IsMemberVersion"
        :safe-area-inset-bottom="true"
      >
        <van-tabbar-item icon="home-o" @click="memuChange('show')"
          >首页</van-tabbar-item
        >
        <van-tabbar-item icon="user-o" @click="memuChange('user')"
          >我的</van-tabbar-item
        >
      </van-tabbar>
      <van-tabbar
        v-model="active"
        :active-color="theme['c1']"
        :z-index="zIndex"
        v-if="!isdefault"
        :safe-area-inset-bottom="true"
      >
        <van-tabbar-item
          v-for="(item, index) in obj"
          :key="index"
          :info="item.url == '/cart' && goodstotal > 0 ? goodstotal : ''"
          :icon="item.iconType == '1' ? item.iconCls : item.imgUrl"
          :id="item.url == '/cart' ? 'carto' : ''"
          @click="memuChangeUrl(item)"
          >{{ item.name }}</van-tabbar-item
        >
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import Utils from './lib/utils'
import Ajax from './lib/ajax'
import {Toast} from "vant";
export default {
  name: 'App',
  data() {
    return {
      obj: {},
      isdefault: false,
      zIndex: 9999,
      showNav: false,
      IsMemberVersion: false,
      active: 0,
    }
  },
  beforeMount() {
    this.getRem(750, 100)
  },
  async created() {
    let ismemberversion = Utils.getIsMemberVersion()
    let enshopid = Utils.siss.auth.getenshopid()
    let shopinfo = localStorage[enshopid + '_shopinfo']
      ? JSON.parse(localStorage[enshopid + '_shopinfo'])
      : ''
    let is_open_shopping_mall = localStorage[enshopid + '_is_open_shopping_mall'] ? JSON.parse(localStorage[enshopid + '_is_open_shopping_mall']) : false
    console.log('is_open_shopping_mall==', is_open_shopping_mall)
    if (!is_open_shopping_mall && enshopid) {
      await this.login()
      return
    }
    // console.log(shopinfo)
    // if (!shopinfo) {
    //   await Ajax.get('/api/services/app/ShopinfoService/GetShopInfoNoCache')
    //     .then((res) => {
    //       shopinfo = res.data.result
    //       //localStorage.setItem[enshopid + '_shopinfo'] ? JSON.parse(localStorage[enshopid + '_shopinfo'])
    //       localStorage.setItem(enshopid + '_shopinfo', JSON.stringify(shopinfo))
    //     })
    //     .catch((err) => {})
    // }
    if (ismemberversion == null && shopinfo) {
      let enddate = new Date(shopinfo.end_date)
      let diff = enddate.getTime() + 24 * 60 * 60 * 1000 - new Date().getTime() //有效期加一天，到23：59
      if (diff <= 0) {
        //商户过期了
        await Ajax.get('/api/services/app/ShopinfoService/GetShopInfoNoCache')
        .then((res) => {
          shopinfo = res.data.result
          localStorage.setItem(enshopid + '_shopinfo', JSON.stringify(shopinfo))
        })
        .catch((err) => {})
         let enddate2 = new Date(shopinfo.end_date)
      let diff2 = enddate2.getTime() + 24 * 60 * 60 * 1000 - new Date().getTime() //有效期加一天，到23：59
      if (diff2 <= 0) {
        this.$router.push('/end')
      }
      }
      let memberVersion = shopinfo.isMemberVersion
      sessionStorage.setItem('ismemberVersion', memberVersion)
      if (memberVersion == '1') {
        this.IsMemberVersion = true
      } else {
        this.IsMemberVersion = false
      }
    } else if(shopinfo){
      let enddate = new Date(shopinfo.end_date)
      let diff = enddate.getTime() + 24 * 60 * 60 * 1000 - new Date().getTime() //有效期加一天，到23：59
      if (diff <= 0) {
        //商户过期了
        await Ajax.get('/api/services/app/ShopinfoService/GetShopInfoNoCache')
        .then((res) => {
          shopinfo = res.data.result
          localStorage.setItem(enshopid + '_shopinfo', JSON.stringify(shopinfo))
        })
        .catch((err) => {})
         let enddate2 = new Date(shopinfo.end_date)
      let diff2 = enddate2.getTime() + 24 * 60 * 60 * 1000 - new Date().getTime() //有效期加一天，到23：59
      if (diff2 <= 0) {
        this.$router.push('/end')
      }
      }
      if (ismemberversion == '1') {
        this.IsMemberVersion = true
      }
    }
  },
  mounted() {
    this.setRouterActive(this.$route.path)
    if (!this.mallNavbar && this.loginstate == '1') {
      //通过分享进来
      this.getNavbar()
    }else{
      this.isdefault=true;
    }
  },
  computed: {
    loginstate() {
      return this.$store.state.user.loginstate
    },
    mallNavbar() {
      return this.$store.state.app.mallNavbar
    },
    theme() {
      return this.$store.state.app.themeColor
    },
    goodstotal() {
      return this.$store.getters.goddsTotal
    },
  },
  watch: {
    loginstate(newVal) {
      if (newVal == '1') {
        //let mallNavbar=sessionStorage.getItem("mallNavbar");
        if (!this.mallNavbar && this.mallNavbar != 'default') {
          this.getNavbar()
        }
        let shopid = Utils.siss.auth.getenshopid();
        // let isgoinggroup = localStorage.getItem(shopid + "_isgoinggroup");
        // let isgroupbuying = localStorage.getItem(shopid + "_isgroupbuying");
        // if(isgoinggroup == 'yes' && isgroupbuying == 'yes'){
        //   this.$router.push('/groupbuying');
        // }
      }
    },
    $route(to, from) {
      let path = to.fullPath
      if (to.path.indexOf('/goodslist/') > -1 && to.params.id) {
        path = to.params.id
      }
      let shopid = Utils.siss.auth.getenshopid();
      // let isgoinggroup = localStorage.getItem(shopid + "_isgoinggroup");
      // if(from.path.indexOf('/groupbuying') > -1 && isgoinggroup == 'yes'){
      //   localStorage.setItem(shopid + "_isgroupbuying",'yes');
      // }
      this.setRouterActive(path)
    },
  },
  methods: {
    getRem(pwidth, prem) {
      var html = document.getElementsByTagName('html')[0]
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth
      html.style.fontSize = (oWidth / pwidth) * prem + 'px'
    },
    async getNavbar() {
      await this.$store
        .dispatch({
          type: 'template/getcurrentnavbar',
          data: {},
        })
        .then((res) => {
          if (res.length > 0) {
            this.obj = res
            this.isdefault = false
            //sessionStorage.setItem("mallNavbar",JSON.stringify(res));
            this.$store.commit('app/changeMallNavbar', JSON.stringify(res))
          } else {
            //sessionStorage.setItem("mallNavbar","default");
            // this.isdefault=true;
            this.$store.commit('app/changeMallNavbar', 'default')
            // this.showNav=true;
          }
          this.setRouterActive(this.$route.path)
        }).catch(res=>{
          this.isdefault=true;
        })
    },
    setRouterActive(path) {
      //let mallNavbar=sessionStorage.getItem("mallNavbar");
      if (this.mallNavbar) {
        if (this.mallNavbar == 'default') {
          this.isdefault = true
        } else {
          this.obj = JSON.parse(this.mallNavbar)
          this.isdefault = false
        }
      } else {
        return
      }
      if (this.isdefault && !this.IsMemberVersion) {
        this.active = path.includes('goods')
          ? 1
          : path.includes('cart')
          ? 2
          : path.includes('user')
          ? 3
          : 0
      }
      if (this.isdefault && this.IsMemberVersion) {
        this.active = path.includes('user') ? 1 : 0
      }
      if (!this.isdefault) {
        var indOf = this.obj.map((item) => item.url).indexOf(path)
        this.active = indOf > -1 ? indOf : 0
        if (indOf > -1) {
          this.showNav = true
        } else {
          this.showNav = false
        }
      }
    },
     memuChange(name) {
      this.$router.push(`/${name}`);
    },
    memuChangeUrl(link) {
      var url = link.url;
      if(url == ''){
        return;
      }
      if (url.indexOf('goodslist/P#') > -1) {
        this.$router.push({
          // path: '/goodslist/',
          name: "goodslistp",
          params: {
            id: url
          }
        });
      } else if (url.indexOf("goodslist/C#") > -1) {
        this.$router.push({
          name: "goodslistc",
          params: {
            id: url
          }
        });
      }else if(url.indexOf("goodslist/B#")>-1){
        this.$router.push({
          name: "goodslistb",
          params: {
            id: url
          }
        });

      } else if (url.indexOf("/tosaoma") > -1) {
        window.wx.miniProgram.navigateTo({
          url: "/pages/scan/scan?scan_scene=goods_barcode&branch=1"
        });
      } else if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1) {
        if (
          url.indexOf("http://testsixunwxd.sissyun.com") > -1 ||
          url.indexOf("https://testsixunwxd.sissyun.com") > -1 ||
          url.indexOf("http://wxdshop.sissyun.com.cn") > -1 ||
          url.indexOf("https://wxdshop.sissyun.com.cn") > -1
        ) {
          if (url.indexOf("?") > -1) {
            url = url + "&token=" + siss.utils.getCookieValue("siss.AuthToken");
          } else {
            url = url + "?token=" + siss.utils.getCookieValue("siss.AuthToken");
          }
        }
      }else if (url.indexOf('/showbranchno') > -1) {
        Ajax.get(
          "/api/services/app/Branch/GetServiceBranchList?latitude=&longitude="
        ).then(res => {
          let branno = url.split("=");
          res.data.result.forEach(element => {
            if (element.branch_No == branno[1]) {
              let branchInfo = {
                branch_name: element.isPickupCenter?element.pickupCenterName:element.branch_Name,
                branch_no: element.branch_No,
                latitude: element.latitude,
                longitude: element.longitude,
                pickupCenterId: element.pickupCenterId ? element.pickupCenterId : null
              };
              this.$store.commit("user/setServiceBranch", branchInfo);
              //更新自提门店选中的门店
              this.$store.commit("updatepickupinstore", {
                branch_no: element.branch_No,
                branch_name: element.branch_Name,
                addr: element.branch_Address,
                lng: element.longitude,
                lat: element.latitude,
                tel: element.tel,
                isDefault: element.isdefault,
                range: element.distance,
                opentime: element.openTime,
                closedtime: element.closedTime
              });
              Ajax.post( "/api/services/app/Branch/SetCurrentBranchRedis",element);
              location.reload();
              return;
            }
          })
        })
      } else if(url.indexOf('/pages') > -1){
          window.wx.miniProgram.navigateTo({
            url: url
          });
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    async login() {
      this.$toast.loading({
        message: "加载中...",
        duration: 0
      });
      let openid = this.$route.query.openid
        ? this.$route.query.openid
        : siss.utils.getCookieValue("User_Ticket");
      let customer_openid = this.$route.query.customer_openid;
      if(!openid){
        // Toast("授权信息已过期，请点击左上角按钮刷新小程序");
        return;
      }
      await this.$store
        .dispatch({
          type: "app/login",
          data: { openid: openid,customer_openid:customer_openid, type: "2" }
        })
        .then(res => {
          let enshopid = Utils.siss.auth.getenshopid()
          let shopinfo = localStorage[enshopid + '_shopinfo']
            ? JSON.parse(localStorage[enshopid + '_shopinfo'])
            : ''
          this.$store.commit("user/setLoginState", "1");
          this.$notify({
            message: "LoginSuccess",
            duration: 10
          });
          this.$toast.clear();
          this.$store.commit("user/setUserInfo", res);
          if (shopinfo) {
            // 开启了购物商城
            if (shopinfo.is_open_shopping_mall) {
              this.$router.push('/show')
            }
          }
        })
        .catch(res => {
          console.log(res)
          this.$toast.loading({
            message: "获取用户信息失败",
            duration: 2000
          });
          sessionStorage.clear();
          Utils.siss.auth.clearToken();
        });
    }
  },
}
</script>
<style>
@import './common/index.css';
.page-content {
  padding-bottom: 50px;
  min-height: 100vh;
  box-sizing: border-box;
}
@font-face {
  font-family: 'shopicon';  /* project id 2419754 */
  src: url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.eot');
  src: url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.woff') format('woff'),
  url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2419754_f9vzk2ovyda.svg#iconfont') format('svg');
}
.shopicon {
  font-family: 'shopicon' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
</style>
